import { styled } from '@mui/material/styles'

import { getSizeStyle } from '@components/Avatar/Avatar.utils'

export const RootWrapper = styled('div')(({ theme }) => ({
  ...getSizeStyle('xxl'),
  borderRadius: theme.spacing(0.5),
}))

export const DropzoneWrapper = styled('div')(({ theme }) => ({
  zIndex: 0,
  width: '100%',
  height: '100%',
  outline: 'none',
  display: 'flex',
  overflow: 'hidden',
  borderRadius: theme.spacing(0.5),
  position: 'relative',
  alignItems: 'center',
  justifyContent: 'center',
  '& > *': { width: '100%', height: '100%' },
}))

export const PlaceholderWrapper = styled('div')(({ theme }) => ({
  cursor: 'pointer',
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.text.contrast,
  backgroundColor: theme.palette.background.backdrop,
  opacity: 0,
  transition: theme.transitions.create('opacity', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&:hover': {
    opacity: 0.85,
  },
}))
